import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState, mapGetters } from 'vuex';
import uniqBy from 'lodash/uniqBy';
export default {
  name: 'CoreTenantBridgeErrors',
  props: {},
  data: function data() {
    return {
      errorBridges: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), mapGetters({
    sessionPrimaryTenantIds: 'authentication/primaryTenantIds',
    sessionUserId: 'authentication/userId'
  })),
  mounted: function mounted() {
    this.loadTenants();
  },
  methods: {
    loadTenants: function loadTenants() {
      var _this = this;

      return Promise.all(this.$store.state.app.permissions['all.manage.tenantIds'].map(function (tenantId) {
        return ApiService.getBridgesWithErrorsForTenantHierarchy(tenantId);
      })).then(function (errorBridges) {
        _this.errorBridges = errorBridges.reduce(function (errorBridges, bridges) {
          return errorBridges.concat(bridges);
        }, []); // it may be possible that the tenantids are overlapping, so the same bridge may be requested multiple times

        _this.errorBridges = uniqBy(_this.errorBridges, function (bridge) {
          return bridge.id;
        });
      }).catch(function (err) {
        // does the user need to be informed here? offer a "reload" button to trigger loading the bridges again?
        console.error('Could not retrieve error tenant-bridges', err);
      }); // return Promise.all(
      //   this.sessionPrimaryTenantIds.map((tenantId) => {
      //     return ApiService.tenantGetById(tenantId, ['no-scope-descendents']);
      //   })
      // )
      //   .then((tenants) => {
      //     const extractAllTenants = (tenant) => {
      //       if (get(tenant, 'children', []).length === 0) {
      //         return [tenant];
      //       }
      //       return tenant.children.reduce(
      //         (tenants, subTenant) => {
      //           return tenants.concat(extractAllTenants(subTenant));
      //         },
      //         [tenant]
      //       );
      //     };
      //     const allTenants = extractAllTenants({ children: tenants }).filter((t) => !!t && !!t.id);
      //     return Promise.all(
      //       allTenants.map((tenant) => {
      //         return ApiService.getBridgesForTenant(tenant.id).then((bridges) => {
      //           return bridges
      //             .map((bridge) => {
      //               if (bridge.state === 'error') {
      //                 return { ...bridge, tenantName: tenant.name };
      //               }
      //               return null;
      //             })
      //             .filter((b) => !!b);
      //         });
      //       })
      //     );
      //   })
      //   .then((tenantBridges) => {
      //     this.errorBridges = tenantBridges.reduce((errorBridges, bridges) => {
      //       return errorBridges.concat(bridges);
      //     }, []);
      //   })
      //   .catch((err) => {
      //     // does the user need to be informed here? offer a "reload" button to trigger loading the bridges again?
      //     console.error('Could not retrieve all tenant-bridges', err);
      //   });
    }
  }
};